import SessionModel from '../models/SessionModel';
import SwabComponentModel from '../models/SwabComponentModel';

export const SET_VIEWING_RESULT = 'SET_VIEWING_RESULT';
export const SET_SELECTED_COLLECTION = 'SET_SELECTED_COLLECTION';
export const SET_WAREHOUSE_CREATED = 'SET_WAREHOUSE_CREATED';
export const SET_SESSIONS_CHANGE = 'SET_SESSIONS_CHANGE';
export const SET_DISPLAY_SESSION_SIDEBAR = 'SET_SELECTED_SESSION_SIDEBAR_ITEM';
export const SET_SELECTED_SESSION = 'SET_SELECTED_SESSION';

export interface ISessionState {
    result?: SwabComponentModel;
    warehouseCreated?: boolean;
    sessionsChange?: boolean;
    sessionSidebar?: boolean;
    selectedSession: SessionModel;
    selectedCollection: number;
}

interface ISetViwingResult {
    type: typeof SET_VIEWING_RESULT;
    payload: SwabComponentModel;
}

interface ISetCollection {
    type: typeof SET_SELECTED_COLLECTION;
    payload: number;
}

interface ISetWarehouseCreated {
    type: typeof SET_WAREHOUSE_CREATED;
    payload: boolean;
}

interface ISetSessionsChange {
    type: typeof SET_SESSIONS_CHANGE;
    payload: boolean;
}

interface ISetDisplaySessionSidebar {
    type: typeof SET_DISPLAY_SESSION_SIDEBAR;
    payload: boolean;
}

interface ISetSelectedSession {
    type: typeof SET_SELECTED_SESSION;
    payload: SessionModel;
}

export type SessionActionTypes =
    | ISetViwingResult
    | ISetCollection
    | ISetWarehouseCreated
    | ISetSessionsChange
    | ISetDisplaySessionSidebar
    | ISetSelectedSession;
